import { Middleware } from 'redux';
import { APP_LOADED } from '../../actions/app';

const createFedopsLogger = (logger): Middleware => {
  return api => next => action => {
    if (action.type === APP_LOADED) {
      window.requestAnimationFrame(() => {
        logger.appLoaded();
      });
    }
    return next(action);
  };
};

export default createFedopsLogger;
